import type { ApiCaseTimelineEvent, ApiCaseTimelinePendingField } from './apiTypes';
import type { CaseTimelineEvent, CaseTimelinePendingField } from './types';

export function convertToCaseTimelineEvent(apiEvent: ApiCaseTimelineEvent): CaseTimelineEvent {
  return {
    taskId: apiEvent.task_id,
    taskName: apiEvent.task_name,
    timestamp: apiEvent.timestamp,
    type: apiEvent.type,
    userId: apiEvent.user_id,
    fieldId: apiEvent.field_id,
    fieldLabel: apiEvent.field_label,
    sectionName: apiEvent.section_name,
    fieldValue: apiEvent.field_value,
    fieldUiType: apiEvent.field_ui_type,
  };
}

export function convertToCaseTimelinePendingField(field: ApiCaseTimelinePendingField): CaseTimelinePendingField {
  return {
    taskId: field.task_id,
    taskName: field.task_name,
    sectionId: field.section_id,
    sectionName: field.section_name,
    fieldId: field.field_id,
    fieldLabel: field.field_label,
  };
}
